import { defineStore } from "pinia";
export const useModeStore = defineStore("modeStore", {
  state: () => ({
    uiStyle: "normal",
  }),
  actions: {
    setUiStyle(val) {
      this.uiStyle = val;
      localStorage.setItem("uiStyle", val);
    },
  },
});
